import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web'

let initialized = false

export function initOpenTelemetry() {
  if (initialized || !dex.config.telemetryCollectorUrl) {
    return
  }

  const exporter = new OTLPTraceExporter({
    url: dex.config.telemetryCollectorUrl
  })

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      'deployment.environment.name': dex.config.name,
      'service.name': 'admin-review-tool-react'
    }),
    spanProcessors: [new BatchSpanProcessor(exporter)]
  })

  provider.register()
  initialized = true
}

export function resetOpenTelemetryForTests() {
  initialized = false
}
